import type { TFunction } from 'i18next';
import { SchedulingValidation } from '@/lib/api/types/adaptive-planner/scenario-item';

export const getSchedulingValidationMessage = (
  validation: SchedulingValidation,
  t: TFunction,
): string => {
  switch (validation) {
    case SchedulingValidation.MissingTeam:
      return t(
        ($) =>
          $.adaptivePlanner.scenarioDetails.table.scheduleBar.tooltip.schedulingValidation
            .MISSING_TEAM,
      );
    case SchedulingValidation.EmptyTeam:
      return t(
        ($) =>
          $.adaptivePlanner.scenarioDetails.table.scheduleBar.tooltip.schedulingValidation
            .EMPTY_TEAM,
      );
    case SchedulingValidation.NoAvailability:
      return t(
        ($) =>
          $.adaptivePlanner.scenarioDetails.table.scheduleBar.tooltip.schedulingValidation
            .NO_AVAILABILITY,
      );
    case SchedulingValidation.TeamUnavailable:
      return t(
        ($) =>
          $.adaptivePlanner.scenarioDetails.table.scheduleBar.tooltip.schedulingValidation
            .TEAM_UNAVAILABLE,
      );
    case SchedulingValidation.MissingEstimation:
      return t(
        ($) =>
          $.adaptivePlanner.scenarioDetails.table.scheduleBar.tooltip.schedulingValidation
            .MISSING_ESTIMATION,
      );
    case SchedulingValidation.InvalidTargetDates:
      return t(
        ($) =>
          $.adaptivePlanner.scenarioDetails.table.scheduleBar.tooltip.schedulingValidation
            .INVALID_TARGET_DATES,
      );
    case SchedulingValidation.ItemIsDone:
      return t(
        ($) =>
          $.adaptivePlanner.scenarioDetails.table.scheduleBar.tooltip.schedulingValidation
            .ITEM_IS_DONE,
      );
    case SchedulingValidation.ParentUnschedulable:
      return t(
        ($) =>
          $.adaptivePlanner.scenarioDetails.table.scheduleBar.tooltip.schedulingValidation
            .PARENT_UNSCHEDULABLE,
      );
    case SchedulingValidation.DependencyUnschedulable:
      return t(
        ($) =>
          $.adaptivePlanner.scenarioDetails.table.scheduleBar.tooltip.schedulingValidation
            .DEPENDENCY_UNSCHEDULABLE,
      );
    case SchedulingValidation.CircularDependency:
      return t(
        ($) =>
          $.adaptivePlanner.scenarioDetails.table.scheduleBar.tooltip.schedulingValidation
            .CIRCULAR_DEPENDENCY,
      );
    case SchedulingValidation.OutsideCalendarLimits:
      return t(
        ($) =>
          $.adaptivePlanner.scenarioDetails.table.scheduleBar.tooltip.schedulingValidation
            .OUTSIDE_CALENDAR_LIMITS,
      );
    default: {
      const _exhaustiveCheck: never = validation;
      return String(_exhaustiveCheck);
    }
  }
};
